export default __webpack_public_path__ + "static/media/celebrate.a4dad82a0950f9cc895f0c6ae3c2ad10.svg";